// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app"
import { getAnalytics } from "firebase/analytics"
import {
  getDatabase,
  ref,
  onValue,
  onDisconnect,
  update,
  orderByChild,
  limitToLast,
  query,
  get,
} from "firebase/database"
import {
  getAuth,
  signInAnonymously,
  onAuthStateChanged,
  // setPersistence,
  // inMemoryPersistence,
  signOut,
} from "firebase/auth"

import store from "store"
import { setState } from "store/socket"
import { leaderboardMockData } from "./FirebaseHelpers"

// COMMON FOR FIREBASE BETWEEN CODEBASES
class FirebaseCommon {
  constructor() {
    this.firebase = {
      database: null,
      attemptsToReconnect: 0,
      analytics: null,
      app: null,
      auth: null,
    }

    this.refs = {
      leaderboard: null,
      baseRefs: {
        leaderboard: null,
      },
      toUpdate: [],
    }

    this.errors = []

    this.details = {
      gameId: null,
      userId: null,
      environment: null,
      signInAttempted: false,
    }

    this.disconnectPayload = {
      // probably don't need this
    }
  }
  init(id) {
    this.details.gameId = id

    this.environmentInit()
    this.setupDatabase()
    this.setupConnectionMonitor()
    this.setupRefs()
    this.setupAuth()
  }
  environmentInit() {}
  setupDatabase(id) {
    if (!this.firebase.database) {
      // const firebaseConfig = {
      //   apiKey: "AIzaSyBMCOS_B2Kr9DUwS7efrInBOZTIuIXSssY",
      //   authDomain: "col---009---att-dashing.firebaseapp.com",
      //   projectId: "col---009---att-dashing",
      //   storageBucket: "col---009---att-dashing.appspot.com",
      //   messagingSenderId: "781364502517",
      //   appId: "1:781364502517:web:23d3180d2d31e3e2c78abc",
      //   measurementId: "G-NYGP0ND97F",
      // };
      const firebaseConfig = {
        apiKey: "AIzaSyDwszcfan-qK6FH8Qd7WrzrTZ_-9CBr28I",
        authDomain: "dashing-to-the-store-2022.firebaseapp.com",
        projectId: "dashing-to-the-store-2022",
        storageBucket: "dashing-to-the-store-2022.appspot.com",
        messagingSenderId: "97327303563",
        appId: "1:97327303563:web:ac61dc006ef37fe7ac7d8e",
      }

      // Initialize Firebase
      this.firebase.app = initializeApp(firebaseConfig)

      this.firebase.analytics = getAnalytics(this.firebase.app)

      this.firebase.database = getDatabase(
        this.firebase.app,
        "https://dashing-to-the-store-2022-default-rtdb.firebaseio.com/"
      )
    }
  }
  setupConnectionMonitor() {
    if (!this.firebase.database) return
    onValue(ref(this.firebase.database, ".info/connected"), (snapshot) => {
      const connected = snapshot.val()

      if (connected) {
        console.log("Firebase:Connected")
        store.dispatch(setState({ connected: true }))
      } else {
        console.log("Firebase:Disconnected")
        store.dispatch(setState({ connected: false }))
      }
    })
  }
  setupRefs() {
    const environment = process.env.REACT_APP_ENVIRONMENT
    this.refs.baseRefs = {
      leaderboard: `/${environment}/users/game3D`,
    }

    this.refs.leaderboardRead = ref(
      this.firebase.database,
      this.refs.baseRefs.leaderboard
    )
  }
  addRefToUpdate(ref) {
    this.refs.toUpdate.push(ref)
    this.onDisconnectRefs()
  }
  signIn() {
    return signInAnonymously(this.firebase.auth)
      .then(() => {
        this.details.signInAttempted = true
      })
      .catch((error) => {
        console.log("SIGN IN ERROR: ", error)
        this.reconnect()
      })
  }
  signOut() {
    this.firebase.attemptsToReconnect = 0
    console.log("Firebase:SignedOut")
    return signOut(this.firebase.auth)
      .then(() => {
        this.reconnect()
      })
      .catch((error) => {
        console.log("SIGN OUT ERROR: ", error)
      })
  }
  reconnect() {
    console.log(this.details.exited)
    if (this.details?.exited) {
      return
    }
    console.log("Firebase:SignInFailed")

    this.details.userId = null

    console.log(this.firebase.attemptsToReconnect)
    if ((this.firebase.attemptsToReconnect += 1) < 3) this.signIn()
  }
  // subscribe(listener) {
  //   if (!this.firebase.database) return;

  //   onValue(
  //     query(this.refs.gameUsers, orderByChild("updatedAt"), limitToLast(10)),
  //     (snapshot) => {
  //       const data = snapshot.val();
  //       console.log("game users ", data);

  //       this.setDetails(data, "user");
  //       this.runUserListeners(listener);
  //     }
  //   );
  // }
  async getLeaderboard() {
    if (!this.firebase.database) return

    let leaderboard = []

    try {
      const snapshot = await get(
        query(this.refs.leaderboardRead, orderByChild("score"), limitToLast(10))
      )

      const data = snapshot.val()

      if (data?.initials) {
        leaderboard = [data]
      } else if (data) {
        leaderboard = Object.keys(data)
          .reduce((acc, key) => {
            if (data[key]?.score > 0) {
              acc.push(data[key])
            }
            return acc
          }, [])
          .sort((userA, userB) => {
            return userB.score - userA.score
          })
      }
    } catch (getLeaderboardErr) {
      console.error("ERROR GETTING LEADERBOARD: ", getLeaderboardErr)
    }

    if (!leaderboard?.length || leaderboard.length === 0) {
      leaderboard = leaderboardMockData
    } else if (leaderboard.length < 10) {
      leaderboard = leaderboard.concat(leaderboardMockData)
      leaderboard.sort((a, b) => b.score - a.score)
      leaderboard.splice(10, leaderboard.length)
    }

    return leaderboard
  }
  updateLeaderboard({ initials = "AAA", score = 1666 }) {
    // No errors on local testing
    if (!this?.details?.gameId) {
      return
    }

    this.updateRefs({
      initials,
      score,
    })
  }
  updateRefs(payload) {
    if (this.refs.toUpdate.length) {
      this.refs.toUpdate.forEach((updateRef) => {
        update(updateRef, {
          ...payload,
          updatedAt: new Date().toISOString(),
        })
      })
    }
  }

  onDisconnectRefs(payload = {}) {
    this.disconnectPayload = {
      ...this.disconnectPayload,
      ...payload,
    }
    if (this.refs.toUpdate.length) {
      this.refs.toUpdate.forEach((updateRef) => {
        onDisconnect(updateRef).update(this.disconnectPayload)
      })
    }
  }

  // setDetails(details, key) {
  //   this.details[key] = null;
  //   if (details) {
  //     if (this.details.userId in details) {
  //       this.details[key] = details[this.details.userId];
  //       if (!this.details[key].connected && !this.details[key].exited) {
  //         store.dispatch(setState({ connected: true }));
  //         this.updateRefs({
  //           connected: true,
  //         });
  //       }
  //     } else {
  //       const ids = Object.keys(details);

  //       for (let u = 0; u < ids.length; u++) {
  //         const item = details[ids[u]];

  //         if (item.connected) {
  //           if (this.details[key]) {
  //             if (
  //               new Date(this.details[key].updatedAt) < new Date(item.updatedAt)
  //             ) {
  //               this.details[key] = item;
  //             }
  //           } else {
  //             this.details[key] = item;
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
  runUserListeners(listener) {
    if (this.handleExited(listener)) return
  }
  runGameListeners(listener) {
    if (this.handleExited(listener)) return
  }
  setupAuth() {
    if (!this.details.userId) {
      this.firebase.auth = getAuth()

      this.signIn()

      onAuthStateChanged(this.firebase.auth, (user) => this.setupUser(user))
      // this.setupUserPersistence();
    }
  }
  setupUser(user) {
    if (user) {
      console.log("Firebase:SignedIn")

      this.details.userId = user.uid

      this.setupUserRefs()
    } else if (this.details.signInAttempted) {
      this.reconnect()
    }
  }
  setupUserRefs() {}
  setupUserPersistence() {}
}

// UNIQUE FOR FIREBASE TO THIS CODEBASE
class FirebaseController extends FirebaseCommon {
  environmentInit() {
    this.details.environment = "mobile"
  }
  setupUserRefs() {
    this.refs.leaderboard = ref(
      this.firebase.database,
      `${this.refs.baseRefs.leaderboard}/${this.details.userId}`
    )

    this.addRefToUpdate(this.refs.leaderboard)
  }
}

export default new FirebaseController()
